import type { GqlLocation } from "~/graphql-client";
import type { RichLocation } from "~/types";

export function mapRichLocation(location: GqlLocation): RichLocation {
  const {
    name,
    id,
    address,
    website,
    coords,
    openingHours,
    phoneNumber,
    social,
    slug,
    orderAheadEnabled,
    orderAtTableEnabled,
    orderDeliveryEnabled,
    timezone,
  } = location;
  const {
    street = null,
    locality = null,
    region = null,
    postalCode = null,
    country = null,
  } = address || {};

  const { facebook = null, instagram = null, twitter = null } = social || {};

  return {
    id,
    ref: slug || id,
    name,
    openingHours,
    phoneNumber,
    address: address ? { street, locality, region, postalCode, country } : null,
    website: website || null,
    coords: coords
      ? {
          latitude: coords.latitude,
          longitude: coords.longitude,
        }
      : undefined,
    social: social ? { facebook, twitter, instagram } : undefined,
    orderAheadEnabled,
    orderAtTableEnabled,
    orderDeliveryEnabled,
    timezone,
  };
}
